import { render, staticRenderFns } from "./rollListItemV2.vue?vue&type=template&id=fca8c088&scoped=true&"
import script from "./rollListItemV2.vue?vue&type=script&lang=js&"
export * from "./rollListItemV2.vue?vue&type=script&lang=js&"
import style0 from "./rollListItemV2.vue?vue&type=style&index=0&id=fca8c088&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca8c088",
  null
  
)

export default component.exports